/**
 * Janela do Ares Sign onde o titular assina (certificado em nuvem, ex.: VIDaaS).
 * A Despacho só abre a página; o Ares Sign conduz a assinatura e avisa a
 * Despacho quando termina.
 */
export default {
  beforeDestroy() {
    this.stopWatchingSignWindow()
  },
  methods: {
    // Tem de rodar direto no clique: depois de um await o bloqueador de pop-ups barra.
    openSignWindow() {
      const width = 520
      const height = 720
      const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2)
      const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2)

      return window.open('', 'ares-assinatura', `width=${width},height=${height},left=${left},top=${top}`)
    },

    // Quando a janela fecha, `onClose` confere com o Ares Sign (o aviso de volta pode demorar).
    watchSignWindow(win, onClose) {
      this.stopWatchingSignWindow()
      this.signWindowTimer = setInterval(() => {
        if (!win || win.closed) {
          this.stopWatchingSignWindow()
          onClose()
        }
      }, 1000)
    },

    stopWatchingSignWindow() {
      if (this.signWindowTimer) {
        clearInterval(this.signWindowTimer)
        this.signWindowTimer = null
      }
    },
  },
}
